// Psychologist/ConfirmationModal.tsx

import React, {useState} from 'react';
import Modal from "Core/components/elements/Modal/Modal";
import {FC, FCCC, FR, FRCC} from 'WideLayout/Layouts';
import Button from "Core/components/elements/Button/Button";
import {useTheme} from "Theme/ThemeContext";
import CircularProgress from "Core/components/elements/CircularProgress";

interface ConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({open, onClose, onConfirm, onCancel}) => {
    const {plt} = useTheme();
    const [isLoading, setIsLoading] = useState<boolean>(false); // Состояние загрузки

    const handleConfirm = async () => {
        setIsLoading(true);
        onConfirm();
    };

    return (
        <Modal
            title={'Как продолжить?'}
            zIndex={33}
            isOpen={open}
            onClose={onClose}
            closeBtn={true}
            closeOnOutsideClick={false}
            cls={'maxw-520px mx-3'}>
            <FC p={1} pos={'relative'}>
                <FR mb={1} pb={1}>
                    У вас есть возможность использовать одну из консультаций на балансе.
                    Хотите списать с баланса или продолжить оплату?
                </FR>
                <FRCC g={1} wrap>
                    <Button
                        onClick={handleConfirm}
                        className={'fw-bold'}
                        sx={{color: '#fff'}}
                        color={plt.colors.secondary.light}
                        variant={'contained'}
                        disabled={isLoading}>
                        Списать с баланса
                    </Button>
                    <Button
                        onClick={onCancel}
                        variant={'contained'}
                        sx={{color: plt.text.primary60}}
                        color={plt.colors.secondary.lighter}
                        disabled={isLoading}>
                        Продолжить оплату
                    </Button>
                </FRCC>
            </FC>
            {isLoading && (
                <FCCC pos={'absolute'} cls={'backdrop-blur-10'}
                      top={0} left={0} zIndex={444} rounded={3}
                      w={'100%'} h={'100%'}>
                    <CircularProgress sx={{marginBottom: '20px'}} size={'3rem'}/>
                </FCCC>
            )}
        </Modal>
    );
};

export default ConfirmationModal;
